import React from 'react';
import { useSelector } from 'react-redux';

import { makeStyles } from '@material-ui/core/styles';

import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import Typography from '@material-ui/core/Typography';

const useStyles = makeStyles(theme => ({
    root: {
      flexGrow: 1,
    },
    ButtonContainer: {
        padding: '0 5px',
    },
    button: {
        width: '100%',
    }  
}));

export default function SearchResultItem(props) {

    const classes = useStyles();
    const libraryState = useSelector(state => state.library)

    const getLibrary = id => libraryState.list.find(library =>
        library['id-biblioteca'] === id
    )

    const truncateString = (title, max = 10) => {
        if(title)
            return title.length > max ? title.substr(0, max-1) + '…' : title
        return ''
    }

    const library = props.item['id-biblioteca']
    const quantity = props.item.quantidade
    const quantityDescription = quantity === 1 ? 'unidade' : 'unidades'

    return (
        <ListItem button alignItems="flex-start" divider={true} onClick={props.onClick}>
            <ListItemText
                primary={
                    <>
                        {truncateString(props.item.titulo, 50)}
                        <Typography
                            component="span"
                            variant="body2"
                            className={classes.inline}
                            color="textSecondary"
                        >
                            &nbsp;- { truncateString(props.item.autor, 40) }
                        </Typography>
                    </>
                }
                secondary={
                    library && !!libraryState.list.length ?
                    `${quantity} ${quantityDescription} em ${getLibrary(library).sigla}` :
                    ''
                } 
            />
        </ListItem>
    )
}